import {lazy} from 'react';

export const AudioContainerLazy = lazy(() => import(/* webpackChunkName: "audioContainer" */ '.'));
